import { createContext } from 'react';
export const MenuRadioGroupContext = createContext(null);
//# sourceMappingURL=MenuRadioGroupContext.js.map